
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".001","width":"24","height":"24","rx":"12","fill":"#00C2FF"}}),_c('path',{attrs:{"d":"M9.785 3.371a3.033 3.033 0 014.432 0c.598.64 1.444.99 2.319.96a3.033 3.033 0 013.134 3.134c-.03.876.32 1.721.96 2.319a3.033 3.033 0 010 4.432 3.033 3.033 0 00-.96 2.319 3.033 3.033 0 01-3.134 3.134c-.875-.03-1.72.32-2.319.96a3.033 3.033 0 01-4.432 0 3.033 3.033 0 00-2.318-.96 3.033 3.033 0 01-3.134-3.134c.03-.876-.32-1.721-.96-2.319a3.033 3.033 0 010-4.432c.64-.598.99-1.443.96-2.319a3.033 3.033 0 013.134-3.134c.875.03 1.72-.32 2.318-.96z","fill":"#0B30B2"}}),_c('path',{attrs:{"d":"M15.78 9.258l-5.184 5.19-1.556-1.555","stroke":"#fff","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    